// eslint-disable-next-line
export default (e: string) => e.replace(/\.|-|\/|\(|\)|\ |/g, '');
